import useGetStudentInfo from 'modules/hooks/get-student-data-hook';
import useGetTeacherInfo from 'modules/hooks/get-teacher-data-hook';
import { AC_LED_MAPPING_ROUTE, AC_LED_MAPPING_ROUTE_V2 } from 'constants/ac-led-mapping';
import useCsmInfo from 'modules/hooks/use-csm-info';

export const BREADCRUMBS = [
  {
    name: 'Home',
    pathName: '/*',
    action: null,
  },
  {
    name: 'Students',
    pathName: '/students*',
    action: null,
  },
  {
    name: null,
    pathName: '/students/:id',
    action: useGetStudentInfo,
  },
  {
    name: 'Teacher Applicants',
    pathName: '/users/teacher-applicants',
    action: null,
  },
  {
    name: 'Contact info',
    pathName: '/pii-info',
    action: null,
  },
  {
    name: 'Curriculumn',
    pathName: '/curriculum-graph',
    action: null,
  },
  {
    name: 'Student Demo',
    pathName: '/users/studentdemos',
    action: null,
  },
  {
    name: 'Payment Link',
    pathName: '/users/payments',
    action: null,
  },
  {
    name: 'Teacher Classroom',
    pathName: '/users/teacher-classrooms',
    action: null,
  },
  {
    name: 'Curriculum Analytics',
    pathName: '/curriculum-analytics',
    action: null,
  },
  {
    name: 'Student Payments',
    pathName: '/student-payments',
    action: null,
  },
  {
    name: 'Pricing Management',
    pathName: '/pricing-management',
    action: null,
  },
  {
    name: 'User Vibe',
    pathName: '/user-vibe',
    action: null,
  },
  {
    name: 'RM Portal',
    pathName: '/users/parent-relationship-managers',
    action: null,
  },
  {
    name: 'Customer Success Managers',
    pathName: '/users/csm*',
    action: null,
  },
  {
    name: null,
    pathName: '/users/csm/:id',
    action: useCsmInfo,
  },
  {
    name: 'Automated Mapping',
    pathName: '/auto-mapping',
    action: null,
  },
  {
    name: 'Workbook Management',
    pathName: '/workbook-management',
    action: null,
  },
  {
    name: 'Learnosity Item Updated',
    pathName: '/learnosity-item-updated',
    action: null,
  },
  {
    name: 'Teachers',
    pathName: '/users/teachers*',
    action: null,
  },
  {
    name: null,
    pathName: '/users/teachers/:id',
    action: useGetTeacherInfo,
  },
  {
    name: 'AC Led Mapping',
    pathName: AC_LED_MAPPING_ROUTE,
    action: null,
  },
  {
    name: 'AC Led Mapping',
    pathName: AC_LED_MAPPING_ROUTE_V2,
    action: null,
  },
  {
    name: 'Student Transfer',
    pathName: '/student-transfer*',
    action: null,
  },
  {
    name: null,
    pathName: '/student-transfer/:teacherId',
    action: useGetTeacherInfo,
  },
  {
    name: 'AV Reviews',
    pathName: '/av-reviews*',
    action: null,
  },
  {
    name: 'Review',
    pathName: '/av-reviews/:reviewId',
    action: null,
  },
  {
    name: 'Settings',
    pathName: '/av-reviews-settings',
    action: null,
  },
  {
    name: 'Trial Analysis',
    pathName: '/trial-dashboard*',
    action: null,
  },
  {
    name: 'Trial Annotation',
    pathName: '/annotate/:teacherClassroomId',
    action: null,
  },
];
